import { ELinkRel } from '../containers/LinkForm/types'
import { checkInternalLink } from './checkInternalLink'

export const getAutoRel = (href: string) => {
  return checkInternalLink(href) ? null : ELinkRel.NOFOLLOW
}
